
    $(function () {
      $('#sidebar-menu').metisMenu();
      $('#menu-collapse').metisMenu();
    });

	
	

	$(document).ready(function() {
			// Show or hide the sticky footer button
			$(window).scroll(function() {
				if ($(this).scrollTop() > 200) {
					$('.go-top').fadeIn(200);
				} else {
					$('.go-top').fadeOut(200);
				}
			});
			
			// Animate the scroll to top
			$('.go-top').click(function(event) {
				event.preventDefault();
				
				$('html, body').animate({scrollTop: 0}, 600);
				easing: 'easeInOutCubic' // the type of easing
			})
		});
	
	
	
	
	
    $(document).ready(function(){
  $('.bxslider').bxSlider({
    auto: true,
    pager: false,
    controls: false,
    speed: 800,
    pause: 9000,
    mode: 'fade',
    adaptiveHeight: true,
    onSliderLoad: function(){
        $(".home-slider").css("visibility", "visible");
      } 
  });
     
});
  
  
  
  
  $(document).ready(function(){
    $("a.gallery").colorbox({rel:'gallery'});
    $(".iframe").colorbox({iframe:true, width:"80%", height:"80%"});
    $(".inline").colorbox({inline:true, width:"80%"});
    });

	
	
	
  $(document).ready(function() {

  var owl = $("#owl-demo");
 
      owl.owlCarousel({
      items : 6, //10 items above 1000px browser width
      itemsDesktop : [1000,5], //5 items between 1000px and 901px
      itemsDesktopSmall : [900,3], // betweem 900px and 601px
      itemsTablet: [600,2], //2 items between 600 and 0
      itemsMobile : [400,1], // itemsMobile disabled - inherit from itemsTablet option
      navigation : true,
	  slideSpeed: 300
  });
 
 
});



    $(document).ready(function() {
$('.owl-carousel').owlCarousel({
    loop:true,
    margin:2,
    nav:true,
    center:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
})
 });
  

  
  
    $('#zoom_01').elevateZoom({
    zoomType: "inner",
cursor: "crosshair",
gallery:'product-gallery',
responsive: true,
imageCrossfade: false, 
zoomWindowFadeIn: 300,
zoomWindowFadeOut: 350,
loadingIcon: 'css/loading.gif'
   }); 
  

  
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})

$('.single-carousel-fade').owlCarousel({
	animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    loop:true,
	autoplay:true,
    lazyLoad : true,
    items:1,
    margin:200,
    stagePadding:0,
	smartSpeed:450
})
